import { Directive, HostBinding, HostListener, Input } from "@angular/core";

@Directive({
  selector: 'img[flag]'
})
export class FlagDirective {

  @Input() flag?: string;

  @HostBinding('src') src!: string;

  ngOnInit() {
    this.src =  this.flag ? `assets/img/flags/${this.flag}.svg` : 'assets/img/flags/world.svg';
  }

  @HostListener('error')
  onError() {
    this.src = 'assets/img/flags/world.svg';
  }
}
